import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import LpExpressRenderer from "./lp-express-renderer";
import { resolveLpStudioPreviewDesign } from "@shared/lp-express-studio";

/** Read-only preview of an admitted document. Never creates copy or images. */
export default function LpExpressSavedStudioPreview({ pageId }: { pageId: string }) {
  const [mobile, setMobile] = useState(false);
  const page = useQuery<any>({
    queryKey: ["/api/landing-pages", pageId],
    queryFn: async () => {
      const response = await fetch(`/api/landing-pages/${encodeURIComponent(pageId)}`, { credentials: "include" });
      if (!response.ok) throw new Error("Saved page unavailable.");
      return response.json();
    },
  });
  const gc = page.data?.generatedContent;
  const design = resolveLpStudioPreviewDesign(gc);
  if (page.isLoading) return <p role="status">Loading saved page</p>;
  if (page.isError || !design) return <p role="alert">Saved Studio page unavailable.</p>;
  return <div className="p-4">
    <Button onClick={() => setMobile(value => !value)}>{mobile ? "Desktop preview" : "Mobile preview"}</Button>
    <div className="mx-auto mt-4" style={{ maxWidth: mobile ? 390 : undefined }}>
      <LpExpressRenderer brand={null} rootProduct={null} products={[]} persona={null} angle={null} sale={null}
        generatedContent={{ ...gc, studioDesign: design }} showStatusDots={false} />
    </div>
  </div>;
}
